export default __webpack_public_path__ + "static/portrait1-8d48b26e5737e0c9ff21c6732119510f.jpg";